﻿document.addEventListener("load",function(){
	//alert("Hi from fotoAlbom.js");
	//Назачаем обработчик клика по фото
	var x = document.querySelectorAll(".faStart >img");
	for (var i = 0; i < x.length; i++){
		//fbid - фото блок id
		if(!!x[i].dataset && !!x[i].dataset.fbid){
			x[i].onclick = FA.fotoView;
			var elem = document.createElement("b");
			elem.innerHTML = "Альбом";
			elem.setAttribute('data-fbid',x[i].dataset.fbid);
			elem.onclick = FA.fotoView;
			x[i].parentNode.appendChild(elem);
		}
	}
	FotoAlbom.querySelector(".faPrev").onclick=FA.prev;
	FotoAlbom.querySelector(".faNext").onclick=FA.next;
	FotoAlbom.querySelector(".faOff").onclick=FA.hide;

	/*Разные имена событий у разных браузеров*/
	document.addEventListener("fullscreenchange", fullScrChange);
	document.addEventListener("webkitfullscreenchange", fullScrChange);
	document.addEventListener("mozfullscreenchange", fullScrChange);
	document.addEventListener("MSFullscreenChange", fullScrChange);
}, true);

var isMobile=((document.ontouchstart === null)?(1):(0));
var W = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
var H = window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight;
var FotoAlbom = document.getElementById('FotoAlbom');

function ajax_get(url, callback) {
	var xmlhttp = new XMLHttpRequest();
	xmlhttp.onreadystatechange = function() {
		if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
			try {
				//var data = JSON.parse(xmlhttp.responseText);
				//static files = JSON.parse(xmlhttp.responseText);
				callback(JSON.parse(xmlhttp.responseText));
			} catch(err) {
				//console.log(err.message + " in " + xmlhttp.responseText);
				return;
			}
		}
	}
	xmlhttp.open("GET", url, true);
	xmlhttp.send();
}

function fullScreen(o){(o.webkitRequestFullScreen||o.mozRequestFullScreen||o.requestFullScreen).call(o);}
function fullScreenCancel(o){(o.webkitCancelFullScreen||o.mozCancelFullScreen||o.cancelFullScreen||o.exitFullscreen).call(o);}

function fullScrChange(){
	/*fullScrEl будет содержать элемент находящийся в полноэкранном режиме. 
	  Если событие сработало при закрытии (после нажатия ESC), fullScrEl будет undefined или null*/
	var fullScrEl=document.fullscreenElement||document.mozFullScreenElement||document.webkitFullscreenElement||document.msFullscreenElement;
	if(fullScrEl == null){//null или undefined. Если произошёл выход из fullScr
		FA.hide();
		fullScreenCancel(document);
	}
}

export class FA {

//var FA=[]; //Фото альбом, все переменные и функции глобальной видимости начинаются с FA.
static ImgPtr=0; //Указатель фото в наборе.
static divPtr=0; //Указатель elements, от 0 до SWIPE_DIVS
static imgNum=0; //количество фото в наборе
static imgs = document.querySelectorAll('.faImgBox > img');
static bufNum=FA.imgs.length; //Количество буферов
static buf=FotoAlbom.querySelectorAll('.faImgBox');
static files=[];

static topMsg=FotoAlbom.querySelector('.faTopMsg');
static btmMsg=FotoAlbom.querySelector('.faBtmMsg');
//static note=FotoAlbom.querySelector('.faBtmMsg');
static imgCount=FotoAlbom.querySelector('.faImgCount');
static prevBtn=FotoAlbom.querySelector('.faPrev');
static nextBtn=FotoAlbom.querySelector('.faNext');

static note=function(txt){
	//FA.btmMsg[FA.btmMsg.value ? "value" : "innerHTML"] = "some value";
	if(txt) FA.btmMsg.innerHTML=FA.imgs[FA.divPtr].note;
	else FA.btmMsg.innerHTML='';
	//if(txt) FA.btmMsg.value=FA.imgs[FA.divPtr].note;
	//else FA.btmMsg.value='';
}

// pure JS Запускаем фотоальбом, показываем первое фото
static fotoView=function(e){
	var o=e.target;
	fullScreen(FotoAlbom);
	//console.log(o);
	//alert(o['click']);
	//if(isMobile && t==1) return false;
	var startId=0;//Первое фото Id = 0 
	var g=o.dataset.fbid;
	//addEventListener("popstate",function(){
	window.onpopstate = function(event) {//Юзер нажал кнопку "назад"
		//alert('onpopstate');
		if(FotoAlbom.style.display=='block') FA.hide();
		//enableScroll();
		//if(document.location.hash!='#foto') alert(document.location.hash);
		//alert(document.location.hash + ", state: " + JSON.stringify(event.state));
	};
	history.pushState({page: 1}, "title 1", "#foto");

	FotoAlbom.addEventListener('touchstart', FA.handleTouchStart, { passive: false });
	FotoAlbom.addEventListener('touchmove', FA.handleTouchMove, false);
	FotoAlbom.addEventListener('touchend', FA.handleTouchEnd, false);
	document.addEventListener("keydown", FA.keyDown, false);

	FA.ImgPtr=startId;
	FA.divPtr=0;

	//disableScroll();

	FA.files=null;
	ajax_get('imgData.php?p='+PgId+'&g='+g+'&w='+W+'&h='+H, function(data){
		FA.files=data;
		//FA.files=JSON.parse(data);
		FA.imgNum=FA.files.length;//

		FA.imgs[0].src=FA.files[startId].src; //
		FA.imgs[0].alt=FA.files[startId].alt;
		FA.imgs[0].note=FA.files[startId].note;

		//Показываем первое фото
		FA.buf[FA.divPtr].style.display='block'
		FA.imgCount.innerHTML=(FA.ImgPtr+1)+'/'+FA.imgNum; //счетчик
		FA.nextBtn.disabled = 0; //Сделать кнопку активной
		if(FA.ImgPtr==0) FA.prevBtn.disabled = 1; //Сделать кнопку не активной
		if((FA.ImgPtr+1) >= FA.imgNum) FA.nextBtn.disabled = 1; //Сделать кнопку не активной

		//if(FA.imgs[FA.divPtr].note) FA.note.innerHTML='<p>'+FA.imgs[FA.divPtr].note+'</p>';
		//else FA.note.innerHTML='';
		FA.note(FA.imgs[FA.divPtr].note);

		FotoAlbom.style.display='block';
		//FotoAlbom.style.visibility = 'visible';
		//FotoAlbom.style.opacity = '1';
	    FotoAlbom.focus();

		/*//Предзагрузка следующего фото
		if(FA.imgNum >1){//Если есть еще фото в списке, загружаем
			FA.imgs[1].src=FA.files[startId+1].src; //
			FA.imgs[1].alt=FA.files[startId+1].alt;
			FA.imgs[1].note=FA.files[startId+1].note;
		}*/
		//Предзагрузка фото справа
		var preLoadPtr=FA.ImgPtr+1;
		if(preLoadPtr < FA.imgNum){//Если есть еще фото в списке, загружаем
			var p1 = FA.divPtr +1;
			if(p1 >= FA.bufNum) p1=0;
			FA.imgs[p1].src=FA.files[preLoadPtr].src; //
			FA.imgs[p1].alt=FA.files[preLoadPtr].alt;
			FA.imgs[p1].note=FA.files[preLoadPtr].note;
		}
		//Предзагрузка фото слева
		preLoadPtr=FA.ImgPtr-1;
		if(preLoadPtr >= 0){//Если есть еще фото в списке, загружаем
			var p1 = FA.divPtr -1;
			if(p1 < 0) p1=FA.bufNum-1;
			FA.imgs[p1].src=FA.files[preLoadPtr].src; //
			FA.imgs[p1].alt=FA.files[preLoadPtr].alt;
			FA.imgs[p1].note=FA.files[preLoadPtr].note;
		}
	});
}

static next=function(){
	//e.stopPropagation();
	//e.preventDefault(); //

	//alert('isMobile='+e);
	//console.log('isMobile='+isMobile);
	//if(isMobile && t==1) return false;
	//Если больше нет фото справа
	if((FA.ImgPtr+1) >= FA.imgNum) return;

	//Скрываем текущее фото
	FA.buf[FA.divPtr].style.display='none'

	//Инкрементируем указатели файлов и блоков DIV
	if(++FA.divPtr >= FA.bufNum) FA.divPtr=0;
	FA.ImgPtr++;

	//Показываем следующее фото предзагруженное предыдущим next() или в fotoView()
	FA.buf[FA.divPtr].style.display='block'
	
	//Выводим дополнительную информацию (описание фото, счетчик)
	//if(FA.imgs[FA.divPtr].note) FA.note.innerHTML='<p>'+FA.imgs[FA.divPtr].note+'</p>';
	//else FA.note.innerHTML='';
	FA.note(FA.imgs[FA.divPtr].note);

	FA.imgCount.innerHTML=(FA.ImgPtr+1)+'/'+FA.imgNum; //счетчик
	FA.prevBtn.disabled = 0; //Сделать кнопку активной
	if((FA.ImgPtr+1) >= FA.imgNum) FA.nextBtn.disabled = 1; //Сделать кнопку не активной

	//Предзагрузка следующего фото
	var preLoadPtr=FA.ImgPtr+1;
	if(preLoadPtr < FA.imgNum){//Если есть еще фото в списке, загружаем
		var p1 = FA.divPtr +1;
		if(p1 >= FA.bufNum) p1=0;
		FA.imgs[p1].src=FA.files[preLoadPtr].src; //
		FA.imgs[p1].alt=FA.files[preLoadPtr].alt;
		FA.imgs[p1].note=FA.files[preLoadPtr].note;
	}
}

static prev=function(){
	//if(isMobile && t==1) return false;

	//Если больше нет фото слева
	if((FA.ImgPtr-1) < 0) return;

	//Скрываем текущее фото
	//FA.buf[FA.divPtr].classList.add("divHide");
	FA.buf[FA.divPtr].style.display='none';

	//Инкрементируем указатели файлов и блоков DIV
	if(--FA.divPtr < 0) FA.divPtr=FA.bufNum-1;
	FA.ImgPtr--;
	//console.log("XX1",'FA.divPtr='+FA.divPtr+', FA.ImgPtr='+FA.ImgPtr+', FA.imgNum='+FA.imgNum);

	//Показываем следующее фото предзагруженное предыдущим next() или в fotoView()
	FA.buf[FA.divPtr].style.display='block';

	//Выводим дополнительную информацию (описание фото, счетчик)
	//if(FA.imgs[FA.divPtr].note) FA.note.innerHTML='<p>'+FA.imgs[FA.divPtr].note+'</p>';
	//else FA.note.innerHTML='';
	FA.note(FA.imgs[FA.divPtr].note);

	FA.imgCount.innerHTML=(FA.ImgPtr+1)+'/'+FA.imgNum; //счетчик
	FA.nextBtn.disabled = 0; //Сделать кнопку next активной
	if(FA.ImgPtr <= 0) FA.prevBtn.disabled = 1; //Сделать кнопку prev не активной

	//Предзагрузка следующего фото
	var preLoadPtr=FA.ImgPtr-1;
	if(preLoadPtr >= 0){//Если есть еще фото в списке, загружаем
		var p1 = FA.divPtr -1;
		if(p1 < 0) p1=FA.bufNum-1;
		FA.imgs[p1].src=FA.files[preLoadPtr].src; //
		FA.imgs[p1].alt=FA.files[preLoadPtr].alt;
		FA.imgs[p1].note=FA.files[preLoadPtr].note;
	}
}

static hide=function(){
	FotoAlbom.removeEventListener("touchstart", FA.handleTouchStart, { passive: false });// 
	FotoAlbom.removeEventListener("touchmove", FA.handleTouchMove, false);// 
	FotoAlbom.removeEventListener("touchend", FA.handleTouchEnd, false);// 
	document.removeEventListener("keydown", FA.keyDown, false);
	FotoAlbom.style.display = 'none';
	//enableScroll();
	fullScreenCancel(document);
}

//Обрабатываем нажатия на клавиатуре
static keyDown=function(e){
	//if(e.shiftKey) return true; 
	if(e.keyCode == '27') { //Esc
		e.preventDefault();
		FA.hide();
	}else if(e.keyCode == '33' || e.keyCode == '37'){ //PgUp или Стрелка влево
		e.preventDefault();
		FA.prev();
	}else if(e.keyCode == '34' || e.keyCode == '39'){//PgDn или Стрелка вправо
		e.preventDefault();
		FA.next();
	}
	//alert(e.keyCode);
}

/*
Обрабатываем жесты SWIPE
*/
//var isMobile=1;
static xDown=0;
static yDown=0;
static isEvTch=0;

static handleTouchStart = function (evt) {
	//evt.stopImmediatePropagation();
	//evt.stopPropagation();
	//evt.preventDefault(); //Закомментировал, чтобы работало редактирование комментариев в хроме.
	FA.xDown = evt.touches[0].clientX;
	FA.yDown = evt.touches[0].clientY;
	//return;
	var clssNm=evt.target.classList[0];
	//alert(clssNm);
	switch (clssNm) {
		case 'faStart':
			FA.fotoView(evt);
			break;
		case 'faOff':
			evt.stopPropagation();
			evt.preventDefault();
			FA.hide();
			break;
		case 'faNext':
			evt.preventDefault();
			FA.next();
			break;
		case 'faPrev':
			evt.preventDefault();
			FA.prev();
			break;
		case 'faImg':
			FA.isEvTch=1;
			break;
		default:
		FA.isEvTch=0;
	}
}

static handleTouchEnd = function (evt){
	return;
}

static handleTouchMove = function(evt) {
	evt.preventDefault();
    if(!FA.isEvTch) {return}

    var xUp = evt.touches[0].clientX;                                    
    var yUp = evt.touches[0].clientY;

    var xDiff = FA.xDown - xUp;
    var yDiff = FA.yDown - yUp;

    if( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
        if( xDiff > 0 ) {//left swipe
			evt.preventDefault();
			FA.next();
        } else {//right swipe
			evt.preventDefault();
			FA.prev();
        }                       
    } else {
        if( yDiff > 0 ){//up swipe
        } else {//down swipe
        }
		FA.topMsg.classList.toggle("faMsgHide");
		FA.btmMsg.classList.toggle("faMsgHide");
    }
    /* reset values */
	FA.isEvTch=0;
}

}//class FA
